<template>
    <cadastro-simples-list
        endpoint="orgao-regional"
        rota-base="/admin/orgao-regional"
        titulo="ÓRGÃOS REGIONAIS"
        titulo-singular="Órgão Regional"
        :colunas-extras='[{"campo":"sigla","label":"Sigla","tipo":"string","maxLength":20},{"campo":"codigo_inep","label":"Código INEP","tipo":"string","maxLength":20}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
